export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_06_XRSeries_end.ac367fa8.jpg";